// Module
var code = "<template> <i ess-icon=\"ui:icons.asterisk\" class=\"ess-error-text fa-2xs\" role=\"img\" aria-label=\"${'ui:labels.required' | t}\"></i> </template> ";
// Exports
module.exports = code;